import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./CourseModules.css";

import {
    Eye,
    Activity,
    Brain,
    CheckCircle2,
    PlayCircle,
    ArrowRight
} from "lucide-react";


const CourseModules = () => {

    /* ==============================
       USER
    ============================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       COURSE STATUS
    ============================== */

    const [
        courseStatus,
        setCourseStatus
    ] = useState({

        neuroPerformanceFoundational:
            false,

        eyeHealthAthleticEdition:
            false,

        eyeHealthDetailed:
            false,

        allCoursesCompleted:
            false

    });


    const [
        loading,
        setLoading
    ] = useState(true);


    /* ==============================
       LOAD COURSE STATUS
    ============================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }

        loadCourseStatus();

    }, [email]);


    const loadCourseStatus = async () => {

        try {

            setLoading(true);


            const res =
                await axios.get(

                    `/api/ignite/course/status/${encodeURIComponent(
                        email
                    )}`

                );


            console.log(
                "COURSE STATUS RESPONSE:",
                res.data
            );


            if (
                res.data?.success
            ) {

                setCourseStatus({

                    neuroPerformanceFoundational:
                        res.data.courses
                            ?.neuroPerformanceFoundational ||
                        false,

                    eyeHealthAthleticEdition:
                        res.data.courses
                            ?.eyeHealthAthleticEdition ||
                        false,

                    eyeHealthDetailed:
                        res.data.courses
                            ?.eyeHealthDetailed ||
                        false,

                    allCoursesCompleted:
                        res.data.allCoursesCompleted ||
                        false

                });

            }

        }

        catch (err) {

            console.error(

                "Course Status Error:",

                err

            );

        }

        finally {

            setLoading(false);

        }

    };


    /* ==============================
       COURSE DATA
    ============================== */

    const courses = [

        {

            id:
                "neuroPerformanceFoundational",

            title:
                "Neuro Performance",

            subtitle:
                "Foundational Program",

            icon:
                <Brain size={30} />,

            color:
                "#8B5CF6",

            completed:
                courseStatus
                    .neuroPerformanceFoundational

        },


        {

            id:
                "eyeHealthAthleticEdition",

            title:
                "Eye Health Reset",

            subtitle:
                "Athletic Edition",

            icon:
                <Activity size={30} />,

            color:
                "#10B981",

            completed:
                courseStatus
                    .eyeHealthAthleticEdition

        },


        {

            id:
                "eyeHealthDetailed",

            title:
                "Eye Health Reset",

            subtitle:
                "Detailed",

            icon:
                <Eye size={30} />,

            color:
                "#2563EB",

            completed:
                courseStatus
                    .eyeHealthDetailed

        }

    ];


    /* ==============================
       STATUS
    ============================== */

    const getStatus = (
        course
    ) => {

        if (
            course.completed
        ) {

            return {

                text:
                    "Completed",

                button:
                    "Review Course"

            };

        }


        return {

            text:
                "Available",

            button:
                "Start Course"

        };

    };


    /* ==============================
       START / REVIEW COURSE
       
       ALL COURSES GO TO
       SAME LEARNING PORTAL
    ============================== */

    const startCourse = () => {

        window.location.href =
            "https://learn.forgeyourpeak.in/web/courses";

    };


    /* ==============================
       LOADING
    ============================== */

    if (loading) {

        return (

            <div
                className="course-modules"
            >

                <div
                    className="course-module-header"
                >

                    <h2>
                        Ignite Learning Path
                    </h2>

                    <p>
                        Loading your courses...
                    </p>

                </div>

            </div>

        );

    }


    /* ==============================
       UI
    ============================== */

    return (

        <div
            className="course-modules"
        >


            {/* =========================
                HEADER
            ========================= */}

            <div
                className="course-module-header"
            >

                <h2>
                    Ignite Learning Path
                </h2>

                <p>
                    Complete every course to master
                    visual and cognitive performance.
                </p>

            </div>


            {/* =========================
                COURSE GRID
            ========================= */}

            <div
                className="course-module-grid"
            >

                {

                    courses.map(
                        (
                            course
                        ) => {

                            const status =
                                getStatus(
                                    course
                                );


                            return (

                                <div

                                    key={
                                        course.id
                                    }

                                    className={

                                        course.completed

                                            ?

                                            "course-module-card completed"

                                            :

                                            "course-module-card"

                                    }

                                >


                                    {/* =================
                                        ICON
                                    ================= */}

                                    <div

                                        className={
                                            "course-module-icon"
                                        }

                                        style={{

                                            background:
                                                course.color

                                        }}

                                    >

                                        {
                                            course.icon
                                        }

                                    </div>


                                    {/* =================
                                        TITLE
                                    ================= */}

                                    <h3>

                                        {
                                            course.title
                                        }

                                    </h3>


                                    <h4>

                                        {
                                            course.subtitle
                                        }

                                    </h4>


                                    {/* =================
                                        STATUS
                                    ================= */}

                                    <span

                                        className={

                                            `course-status ${
                                                status.text
                                                    .replace(
                                                        /\s/g,
                                                        ""
                                                    )
                                                    .toLowerCase()
                                            }`

                                        }

                                    >

                                        {

                                            course.completed

                                                ?

                                                <CheckCircle2
                                                    size={16}
                                                />

                                                :

                                                <PlayCircle
                                                    size={16}
                                                />

                                        }


                                        {
                                            status.text
                                        }

                                    </span>


                                    {/* =================
                                        PROGRESS
                                    ================= */}

                                    <div
                                        className={
                                            "course-progress-bar"
                                        }
                                    >

                                        <div

                                            className={
                                                "course-progress-fill"
                                            }

                                            style={{

                                                width:

                                                    course.completed

                                                        ?

                                                        "100%"

                                                        :

                                                        "0%"

                                            }}

                                        />

                                    </div>


                                    {/* =================
                                        BUTTON
                                    ================= */}

                                    <button

                                        onClick={
                                            startCourse
                                        }

                                    >

                                        {
                                            status.button
                                        }

                                        <ArrowRight
                                            size={16}
                                        />

                                    </button>


                                </div>

                            );

                        }
                    )

                }

            </div>

        </div>

    );

};


export default CourseModules;